import { render } from "./OnboardingWizard.vue?vue&type=template&id=32d23e48&scoped=true"
import script from "./OnboardingWizard.vue?vue&type=script&lang=js"
export * from "./OnboardingWizard.vue?vue&type=script&lang=js"

import "./OnboardingWizard.vue?vue&type=style&index=0&id=32d23e48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d23e48"]])

export default __exports__